import { IBanner } from '~/assets/interfaces/banners'
import {
  ICatalogCategoryItem,
  ICatalogFilterItem,
} from '~/assets/interfaces/catalog'
import { IMeta } from '~/assets/interfaces/meta'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
import { IProductsRaw } from '~/assets/interfaces/products'

export interface ICatalogPopularSearches {
  title: string
  items: { title: string; url: string }[]
}

export interface ICatalogSections {
  items: ICatalogCategoryItem[]
}

// Данные страницы каталога после нормализации ответа /catalog/{slug}.
export interface ICatalogPageData {
  meta: IMeta | null
  breadcrumbs: IBreadcrumbsItem[]
  pages: number
  amount: number
  seoFilters: unknown[]
  sections: ICatalogSections | null
  categoryPath: unknown
  filter: ICatalogFilterItem[] | null
  banners: IBanner[]
  sorting: unknown[]
  products: IProductsRaw | null
  productsAdditionalIds: number[]
  seo: unknown
  popularSearches: ICatalogPopularSearches | null
}

// Ответ бэка → поля страницы с дефолтами. Одно место вместо двух: раньше
// asyncData возвращал ответ как есть, а обновление по смене фильтров
// раскладывало его руками, и списки дефолтов расходились.
export function normalizeCatalogResponse(
  response: Record<string, any>
): ICatalogPageData {
  return {
    meta: response.meta || null,
    breadcrumbs: response.breadcrumbs || [],
    pages: response.pages || 0,
    amount: response.amount || 0,
    seoFilters: response.seoFilters || [],
    sections: response.sections || null,
    categoryPath: response.categoryPath || null,
    filter: response.filter || null,
    banners: response.banners || [],
    sorting: response.sorting || [],
    products: response.products || null,
    productsAdditionalIds: response.productsAdditionalIds || [],
    seo: response.seo || null,
    popularSearches: response.popularSearches || null,
  }
}
